module.exports = __webpack_public_path__ + "img/user-vip.008cf7c1.png";